export default "__VITE_PUBLIC_ASSET__0d6016f9__"